// ════════════════════════════════════════════════════════════════════════
//  Adressen im Bereich Lehrgänge
//
//  Der Slug steht in der Adresse, weil er die Auswahl IST: die Liste links
//  gehört zu einem Lehrgang, die Fassungsleiste auch, und ein Lesezeichen soll
//  auf denselben zurückführen. Hier steht die Bildung einmal, damit sie nicht an
//  zwölf Stellen einzeln nachgezogen werden muss.
// ════════════════════════════════════════════════════════════════════════

import { useParams } from "react-router-dom";

/** Die Liste aller Lehrgänge. */
export const COURSES = "/lehrgaenge";

export function coursePath(slug: string, rest = ""): string {
  return rest === "" ? `${COURSES}/${slug}` : `${COURSES}/${slug}/${rest}`;
}

/** Der Lehrgang aus der Adresse. Leer außerhalb des Bereichs. */
export function useCourseSlug(): string {
  return useParams().slug ?? "";
}
